/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Pricing_Storage_LabelInputs */



/**
* | output |
* | --- |
* | "Storage & Delivery:" |
*
* @param {Embed_Captions_Pricing_Storage_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_storage_label = /** @type {((inputs?: Embed_Captions_Pricing_Storage_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_Storage_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Stockage et livraison :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lagerung & Lieferung:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stoccaggio e consegna:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Хранение и доставка:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Almacenamiento y entrega:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("仓储与配送：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保管と配送:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भंडारण और वितरण:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Armazenamento e entrega:")
	return /** @type {LocalizedString} */ ("Storage & Delivery:")
});